import { mixin as clickaway } from 'vue-clickaway';

import template from './slide-selector.vhtml';
import './slide-selector.scss';

export default {	
	mixins: [ clickaway ],
	template,
	props: {
		selections: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			isOpen: false,
			items: [],
		}
	},
	methods: {
		slideDown( el ) { 
			 if ( !el.active ) {
				 this.items[0].active = 0;
				 this.items.forEach((item, index) => {
					 if ( item.code == el.code ) {
						 const elm = this.items.splice(index, 1)[0];
						elm.active = 1;
						 this.items.unshift(elm);
					 }

				 });
				this.navigateTo( el.url );
			}
			this.isOpen = el.active && this.isOpen === false;
		},
		slideUp() {
			if ( this.isOpen ) {
				this.isOpen = false;
			}
		},
		navigateTo( url ) {
			window.location.href = url;
		}
	},
	mounted() {
		this.items = this.selections;
		this.items.forEach( ( item, index ) => {
			if ( item.active ) {
				const elm = this.items.splice( index, 1 );
				this.items.unshift( elm[0] );
			}
		});
	},
}


// WEBPACK FOOTER //
// ./assets/_js/components/slide-selector/slide-selector.js